<template>
    <div class="h-100 position-relative">
        <b-card no-body>
            <template #header>
                <div
                    class="w-100 d-flex flex-column flex-lg-row justify-content-between align-items-center"
                >
                    <b-card-title class="mb-1 mb-lg-0">{{
                        $t('statistics.cardsTitle')
                    }}</b-card-title>

                    <form-date-range-presets
                        class="ml-auto"
                        :is-loading="isLoading"
                        :show-scale-selector="false"
                        @update="fetchCardsStatistics"
                    />
                </div>
            </template>
        </b-card>

        <div v-if="isLoading" class="centered">
            <b-spinner variant="primary" />
        </div>

        <b-row v-else>
            <b-col class="mb-2" xl="6">
                <statistics-chart
                    :counters="cards"
                    :total="statistics.cards.total"
                    statistics-type="cards"
                >
                    <template #title>
                        {{ $t('statistics.cards.title') }}
                    </template>
                </statistics-chart>
            </b-col>

            <b-col class="mb-2" xl="6">
                <statistics-chart
                    :counters="statistics.cardsAlive.transactions"
                    :total="statistics.cardsAlive.count"
                    statistics-type="cardsAlive"
                >
                    <template #title>
                        {{ $t('statistics.cardsAlive.title') }}
                    </template>
                </statistics-chart>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { BCard, BCardTitle, BRow, BCol, BSpinner } from 'bootstrap-vue';
import FormDateRangePresets from '../statistics-components/statistics-form/FormDateRangePresets.vue';
import useStatisticsCards from '../useStatistics';
import StatisticsChart from '../statistics-components/StatisticsChart.vue';

export default {
    components: {
        BCard,
        BCardTitle,
        BRow,
        BCol,
        BSpinner,

        FormDateRangePresets,
        StatisticsChart,
    },

    computed: {
        cards() {
            const cards = { ...this.statistics.cards };
            delete cards.total;

            return cards;
        },
    },

    setup() {
        const {
            statistics,
            isLoading,
            fetchCardsStatistics,
        } = useStatisticsCards();

        return {
            // Reactive data
            statistics,
            isLoading,

            // Methods
            fetchCardsStatistics,
        };
    },
};
</script>

<style lang="scss" scoped>
.centered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
